module.exports = __webpack_public_path__ + "static/media/login.9a76e74e.svg";